<div class="login-wrapper">
    <!-- Lado esquerdo - Branding (apenas Desktop/Tablet) -->
    <div class="login-branding hidden-mobile">
        <div class="branding-content">
            <div class="brand-logo">
                <i class="ti ti-chart-line"></i>
            </div>
            <h1 class="brand-title">{{ 'APP.TITLE' | translate }}</h1>
            <p class="brand-subtitle">{{ 'APP.SUBTITLE' | translate }}</p>

            <div class="features-list">
                <div class="feature-item">
                    <i class="ti ti-shield-check"></i>
                    <span>Segurança avançada</span>
                </div>
                <div class="feature-item">
                    <i class="ti ti-chart-arrows-vertical"></i>
                    <span>Análise inteligente</span>
                </div>
                <div class="feature-item">
                    <i class="ti ti-lock-access"></i>
                    <span>Acesso controlado</span>
                </div>
            </div>
        </div>

        <!-- Decorative elements -->
        <div class="decoration-circle circle-1"></div>
        <div class="decoration-circle circle-2"></div>
        <div class="decoration-circle circle-3"></div>
    </div>

    <!-- Lado direito - Formulário -->
    <div class="login-form-container">
        <div class="login-card">
            <!-- Logo mobile (aparece apenas em mobile) -->
            <div class="mobile-logo">
                <div class="mobile-logo-icon">
                    <i class="ti ti-chart-line"></i>
                </div>
                <h2 class="mobile-brand-title">{{ 'APP.TITLE' | translate }}</h2>
                <p class="mobile-brand-subtitle">{{ 'APP.SUBTITLE' | translate }}</p>
            </div>

            <div class="login-header">
                <h2 class="login-title">Bem-vindo de volta</h2>
                <p class="login-description">Entre com suas credenciais para continuar</p>
            </div>

            <form [formGroup]="form" (ngSubmit)="onSubmit()" class="login-form">
                <!-- Campo de E-mail -->
                <app-input
                    formControlName="email"
                    type="email"
                    label="LOGIN.EMAIL"
                    placeholder="LOGIN.EMAIL_PLACEHOLDER"
                    groupIcon="mail"
                    groupIconPosition="left"
                    autocomplete="email"
                    containerStyles="mb-3"
                    [readonly]="loading"
                />

                <!-- Campo de Senha -->
                <div class="password-field-wrapper">
                    <app-input
                        formControlName="password"
                        [type]="showPassword() ? 'text' : 'password'"
                        label="LOGIN.PASSWORD"
                        placeholder="LOGIN.PASSWORD_PLACEHOLDER"
                        groupIcon="lock"
                        groupIconPosition="left"
                        autocomplete="current-password"
                        containerStyles="mb-0"
                        [readonly]="loading"
                    />
                    <button
                        type="button"
                        class="password-toggle"
                        (click)="togglePasswordVisibility()"
                        [disabled]="loading"
                        tabindex="-1"
                        aria-label="Toggle password visibility">
                        <i class="ti" [ngClass]="showPassword() ? 'ti-eye-off' : 'ti-eye'"></i>
                    </button>
                </div>

                <!-- Opções -->
                <div class="login-options">
                    <div class="remember-me-wrapper">
                        <input
                            type="checkbox"
                            id="rememberMe"
                            class="custom-checkbox"
                            [checked]="rememberMe()"
                            (change)="toggleRememberMe()"
                            [disabled]="loading">
                        <label for="rememberMe" class="checkbox-label">
                            {{ 'LOGIN.REMEMBER_ME' | translate }}
                        </label>
                    </div>
                </div>

                <!-- Botão de Login -->
                <button
                    type="submit"
                    class="btn-login"
                    [disabled]="loading || form.invalid"
                    [class.loading]="loading">
                    @if (loading) {
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span>{{ 'LOGIN.SIGNING_IN' | translate }}</span>
                    } @else {
                        <i class="ti ti-login-2"></i>
                        <span>{{ 'LOGIN.SIGN_IN' | translate }}</span>
                    }
                </button>
            </form>

            <div class="login-footer">
                <p class="version-info">
                    <i class="ti ti-code"></i>
                    {{ 'APP.VERSION' | translate }}
                </p>
            </div>
        </div>
    </div>
</div>



